export default {
  headerContent: {
    title: 'Fibaemeklilik BES Bireysel Emeklilik Sistemi Hesaplama',
    slogan: "Bireysel Emeklilik Sistemi'ni işin uzmanına bırak.",
    btnTitle: 'BİREYSEL EMEKLİLİK SİSTEMİ TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Fibaemeklilik Bireysel Emeklilik Sistemi ',
    description: {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Nedir?',
      content: [
        'Bireysel Emeklilik Sistemi (BES), kişilerin gelecek dönemleri için birikim yapmalarını sağlar. Özel emeklilik için para biriktirmenize yardımcı olmayı amaçlayan emeklilik türüdür. Değerleri genellikle ne kadar para ödediğinize ve yatırımlarınızın nasıl performans gösterdiğine bağlıdır.',
        'Bireysel Emeklilik Sistemi (BES), kişilerin gelecek dönemleri için birikim yapmalarını sağlar. Özel emeklilik için para biriktirmenize yardımcı olmayı amaçlayan emeklilik türüdür. Değerleri genellikle ne kadar para ödediğinize ve yatırımlarınızın nasıl performans gösterdiğine bağlıdır.',
        'Fibaemeklilik ile BES hesabınızı oluşturarak geleceğiniz için ek gelir hazırlığı yapabilir, refah seviyenizi arttırabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Zorunlu Mu?',
      content: [
        {
          paragraph: 'Bireysel emeklilik sistemi kapsamında sunulan fonlar ve planlar zorunlu değildir. Geleceğe yönelik yatırım yapmak isteyen kişiler BES hesabına kayıt olabilir.',
          subList: null
        },
        {
          paragraph: 'Hayatımızın ilerleyen dönemlerinde emekli aylığı sıkıntısını önlemek için, emekli aylıklarımızı karşılayabildiğimiz kadarını ödememiz tavsiye edilir. Ve ne kadar erken başlarsak o kadar iyi. ',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Bireysel Emeklilik Sistemi Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Bireysel Emeklilik Sistemi',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Bireysel Emeklilik Sistemi',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Bireysel Emeklilik Sistemi',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Bireysel Emeklilik Sistemi',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Bireysel emeklilik sistemi kapsamında sunulan fonlar ve planlar zorunlu değildir. Geleceğe yönelik yatırım yapmak isteyen kişiler BES hesabına kayıt olabilir.',
          subList: null
        },
        {
          paragraph:
            'Hayatımızın ilerleyen dönemlerinde emekli aylığı sıkıntısını önlemek için, emekli aylıklarımızı karşılayabildiğimiz kadarını ödememiz tavsiye edilir. Ve ne kadar erken başlarsak o kadar iyi. ',
          subList: null
        }
      ]
    },
    {
      title: 'Bireysel Emeklilik Sistemi (BES) Devlet Katkısı Nedir?',
      content: [
        {
          paragraph:
            'BES Devlet Katkısı, 1 Ocak 2013 yılından itibaren ödenen katkı payları için geçerli olmaktadır. Bu tarihten önce olan hesapları kapsamaz.',
          subList: null
        },
        {
          paragraph:
            'Devlet Katkısı, o yıla ait brüt asgari ücret tutarının % 25\'ini geçemez.',
          subList: null
        },
        {
          paragraph:
            '** Birden fazla Bireysel Emeklilik sözleşmesi olan kişiler için Devlet Katkıları, her sözleşme bazında ayrı ayrı paylaştırılır. Fakat toplam hakkın Asgari Brüt Ücret ’in %25’i kadarı olur.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Birikim hesabı BES, emeklilik döneminiz için destek sağlar. Normal emekliliğin yanı sıra isteğe bağlı yaptırılan ve uzun vadeli yatırım aracı olarak bilinen bireysel emeklilik sistemi, sistemde gerekli şartları yerine getiren adayları emekli yapar.',
          subList: null
        },
        {
          paragraph:
            'Bireysel emeklilik sisteminden emekli olmak isteyen kişiler 10 yıl sistemde kalarak 56 yaşını doldurmalıdır. Emekliliğiniz için yapacağınız birikimler hesabınıza devlet katkısı ile %25 avantajlı eklenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Fibaemeklilik\'ten BES Yaptırmalıyım?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Bireysel emeklilik kapsamında sunulan farklı planlar ile birikim amacınıza uygun plan tercih edebilirsiniz.',
            'Birikimlerinize %25 Devlet Katkısı eklenir ve yatırımlarını artar.',
            'Planlarınız doğrultusunda istediğiniz zaman BES’e ara verebilirsiniz.',
            'Birikimlerinizi aylık, 3 aylık, 6 aylık veya yıllık olarak yapabilirsiniz.',
            'Bir yılda 4 kere BES planını, 6 kere de fon değişikliği yapabilirsiniz.',
            'Dövizli BES başvurusu yapabilirsiniz.',
            'Profesyonel uzman desteği ile fonlarınızı en iyi şekilde yönetebilirsiniz.',
            'Birikimlerinizi online 7 gün 24 saat aralıksız takip edebilirsiniz.'
          ]
        }
      ]
    },
    {
      title: 'Bireysel Emekliliğe Kimin İhtiyacı Var?',
      content: [
        {
          paragraph:
            'İşyerinde emekliliğiniz olsa bile bireysel emeklilik hesabı açabilirsiniz. İşverenlerin, çalışanlarının emeklilik planlarına Otomatik Kayıt kapsamındaki emeklilik planlarına katkıda bulunmaları gerekmektedir, bu da işyeri emekliliklerini özellikle çekici hale getirebilir. ',
          subList: null
        },
        {
          paragraph:
            'İşyerinde emeklilik maaşınız yoksa - belki de şirket emeklilik planınızı devre dışı bıraktığınız için ya da serbest meslek sahibi olduğunuz için - o zaman bir özel emeklilik başlatmak emeklilik tasarrufunuzu başlatmanın bir yoludur. Ancak, bir emekli maaşını diğerine tercih etmeyin ve hem işyeri hem de özel seçeneklerde tasarruf etmeye çalışın. İşverenler sonuçta işyeri emekli maaşlarına katkıda bulunur.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi (BES) Planları Nelerdir?',
      content: [
        {
          paragraph:
            'Fibaemeklilik size özel 4 ayrı Emeklilik Planı sunuyor:',
          subList: [
            '1009 Bireysel Emeklilik Planı (Bu planın aylık asgari katkı payı tutarı 150 TL’dir.)',
            '2040-1 Bireysel Emeklilik Planı (Bu planın aylık asgari katkı payı tutarı 150 TL’dir.)',
            '2040-2 Bireysel Emeklilik Planı (Bu planın aylık asgari katkı payı tutarı 350 TL’dir.)',
            '2040-3 Bireysel Emeklilik Planı (Bu planın aylık asgari katkı payı tutarı 1.000 TL’dir.)'
          ]
        }
      ]
    },
    {
      title: 'Fibaemeklilik BES Fon Dağılımı Değiştirilebilir Mi?',
      content: [
        {
          paragraph:
            'Fon değişikliğine gidebilirsiniz. BES hesabınız kapsamında yılda 6 kez Fon Dağılımı talep edebilirsiniz. Yatırım amacınız ve birikim düzeyinizi göz önünde bulundurarak fon değişimlerinizi yapmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik’te Fonlarım Nasıl Yönetilir?',
      content: [
        {
          paragraph:
            'Bireysel Emeklilik Sistemi kapsamında açmış olduğunuz BES hesabınızın ödemeleri profesyonel fon yöneticileri tarafından yönetilmektedir. Bu sebeple hesabınızı kontrol etmeniz kolaylaşır.',
          subList: null
        },
        {
          paragraph:
            'Hesabınızı oluştururken bir fon dağılımda bulunmamışsanız birikimleriniz standart fonda yönetilir. Tüm fonlarınız Fiba Portföy Yönetim A.Ş. uzman kadrosu tarafından güvenle yönetilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik BES Kıdem Fonu Nedir?',
      content: [
        {
          paragraph:
            'Kıdem fonu, kıdem tazminatının fonlu bir sisteme geçirilmesidir. Kıdem fonu aynı zamanda Tamamlayıcı Emeklilik Sistemi ile entegre edilmiş halidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik BES Kıdem Fonu Nasıl Çalışacak?',
      content: [
        {
          paragraph:
            'Kıdem, her yılın sonunda işvereniniz tarafından fon hesabına yatırılır.',
          subList: null
        },
        {
          paragraph:
            'Kıdem birikimi emeklilik zamanı gelince alınır. Kıdemin yatıp yatmadığını, ne kadar birikiminizin olduğunu ise hesabınızdan kolayca takip edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kimler Fibaemeklilik’ten Bireysel Emeklilik Yaptırabilir?',
      content: [
        {
          paragraph:
            'Fibaemeklilik’ten BES hesabı oluşturmak isteyen adaylar 18 yaşını doldurmuş olmalıdır.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemi Güvenli Mi?',
      content: [
        {
          paragraph:
            'Emeklilik şirketlerinin yürütmüş olduğu faaliyetler T.C. Hazine Müsteşarlığı tarafından denetlenmektedir. Finaemeklilik’ te BES hesabınız güvenlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Sistemine En Az Ne Kadar Ödenir?',
      content: [
        {
          paragraph:
            'Bireysel Emeklilik Planları çerçevesinde size özel sunulacak olan her biri için “Asgari Katkı Payı” tutarı belirlenmiştir. Her planın kendine özgü minimum ödeme miktarı vardır.',
          subList: null
        },
        {
          paragraph:
            'Verimli bir hesap açmak ve devam etmek isteyenlere önerilen minimum Katkı Payı tutarı 150 TL’dir. ',
          subList: null
        },
        {
          paragraph:
            'BES için minimum ödeme miktarı dışında ödemeler için belirlenmiş olan bir üst bir limit yoktur. ',
          subList: null
        }
      ]
    },
    {
      title: 'Fibaemeklilik Bireysel Emeklilik Hakkı Nasıl Kazanılır?',
      content: [
        {
          paragraph:
            'BES’e giriş yapmak isteyen müşterilerimiz bilgilerini alokasko.com uzmanlarına ileterek en uygun fonları değerlendirebilir.',
          subList: null
        },
        {
          paragraph:
            'Uzman sigorta danışmanlarımız yatırım yapmak istediğiniz adımları değerlendirir ve sizin için en iyi fonları sunar. Bireysel emeklilik sisteminden, mümkün olduğunca çok tasarruf etmeniz tavsiye edilebilir. ',
          subList: null
        },
        {
          paragraph:
            'BES hesabı oluşturmak isteyen 18 yaş ve üstü adaylar başvuru formunu doldurarak bilgilerini uzmanlarımıza iletebilir.',
          subList: null
        }
      ]
    }
  ]
}
